import { AnimatedSection } from "./AnimatedSection";
import { ArrowRight } from "lucide-react";
import { analytics } from "@/lib/analytics";

const supplierPoints = [
  "Reach serious buyers",
  "Reduce wasted time on non-serious inquiries",
  "Improve visibility of supply",
  "Move faster from listing to deal",
];

export function SupplierSection({ openModal }) {
  return (
    <section id="supplier-section" className="py-24 md:py-32 bg-[#09120D]" data-testid="supplier-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <AnimatedSection delay={0.15} className="order-2 lg:order-1">
            <div className="bg-[#050A07] border border-[#1A2E22] p-10 lg:p-14">
              <div className="space-y-6">
                <div className="flex items-center justify-between border-b border-[#1A2E22] pb-4">
                  <span className="text-[#A1B2A8] text-sm">Buyer Quality</span>
                  <span className="text-[#22C55E] font-['Outfit'] font-semibold">Serious</span>
                </div>
                <div className="flex items-center justify-between border-b border-[#1A2E22] pb-4">
                  <span className="text-[#A1B2A8] text-sm">Inquiry Conversion</span>
                  <span className="text-[#22C55E] font-['Outfit'] font-semibold">Higher</span>
                </div>
                <div className="flex items-center justify-between border-b border-[#1A2E22] pb-4">
                  <span className="text-[#A1B2A8] text-sm">Supply Visibility</span>
                  <span className="text-[#22C55E] font-['Outfit'] font-semibold">Enhanced</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-[#A1B2A8] text-sm">Listing to Deal</span>
                  <span className="text-[#22C55E] font-['Outfit'] font-semibold">Accelerated</span>
                </div>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection className="order-1 lg:order-2">
            <p className="text-[#22C55E] text-sm font-medium tracking-widest uppercase mb-4">
              For Suppliers
            </p>
            <h2 className="font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
              For Suppliers
            </h2>
            <div className="mt-8 space-y-4">
              {supplierPoints.map((point, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-1.5 h-1.5 bg-[#22C55E] flex-shrink-0" />
                  <p className="text-[#A1B2A8] text-base">{point}</p>
                </div>
              ))}
            </div>
            <button
              onClick={() => { analytics.ctaClicked("Apply as Supplier", "supplier_section"); openModal("supplier"); }}
              className="mt-10 bg-transparent border border-[#22C55E] text-[#22C55E] hover:bg-[#22C55E]/10 transition-all px-8 py-4 font-medium font-['Outfit'] inline-flex items-center gap-2 group"
              data-testid="supplier-apply-btn"
            >
              Apply as Supplier
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
